import { useQuery } from "@tanstack/react-query";

export interface CrmUser { id: string; name: string | null; email: string | null; initials: string | null; isActive: boolean | null }

/** Active users, sorted by name. Backs the owner and partner pickers. */
export function useUsers() {
  return useQuery<CrmUser[]>({
    queryKey: ["/api/users"],
    queryFn: async () => {
      const r = await fetch("/api/users", { credentials: "include" });
      if (!r.ok) throw new Error("Failed to load users");
      const all: CrmUser[] = await r.json();
      return all.filter((u) => u.isActive !== false).sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    },
    staleTime: 5 * 60_000,
  });
}
